var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 26,
    viewBox: "0 0 16 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter_2348_5239_dd",
    x: 0,
    y: 0,
    width: 16,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.133333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect_innerShadow_1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter_2348_5239_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 6.62C-0.01 6.71 0.01 6.8 0.04 6.89C0.08 6.98 0.13 7.06 0.19 7.13C0.26 7.19 0.34 7.25 0.43 7.28C0.52 7.32 0.61 7.33 0.71 7.33L3.14 7.33C3.55 7.33 3.87 7 3.93 6.61C4.19 4.71 5.52 3.32 7.88 3.32C9.91 3.32 11.76 4.32 11.76 6.71C11.76 8.55 10.66 9.39 8.91 10.68C6.93 12.09 5.36 13.75 5.47 16.43L5.48 17.06C5.48 17.25 5.56 17.43 5.7 17.57C5.84 17.7 6.02 17.77 6.21 17.77L8.61 17.77C8.8 17.77 8.99 17.7 9.13 17.56C9.27 17.43 9.35 17.24 9.35 17.05L9.35 16.75C9.35 14.67 10.15 14.06 12.32 12.44C14.12 11.1 16 9.61 16 6.49C16 2.11 12.23 0 8.11 0C4.37 0 0.28 1.7 0 6.62ZM4.59 23.31C4.59 24.85 5.84 26 7.57 26C9.37 26 10.6 24.85 10.6 23.31C10.6 21.71 9.36 20.59 7.57 20.59C5.84 20.59 4.59 21.71 4.59 23.31Z",
    fill: "#00A03C",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHelp);
export default __webpack_public_path__ + "static/media/ico_help.0fbbb1528f3ee7b4d99b9cfe5d23a584.svg";
export { ForwardRef as ReactComponent };